import { createTheme } from '@mui/material/styles';

import breakpoints from 'utils/breakpoints';
import { getColor } from 'utils/colors';
import { remCalc } from 'utils/remCalc';

const theme = createTheme({
	breakpoints: breakpoints,
});

export const overrides = {
	'.crowdRiffGallery': {
		paddingTop: remCalc(40),
		paddingBottom: remCalc(40),
		[theme.breakpoints.up('sm')]: {
			paddingTop: remCalc(80),
			paddingBottom: remCalc(80),
		}
	},
	'.crowdRiffGallery__subheader': {
		color: getColor('ivory', 600),
		fontSize: remCalc(32),
		fontFamily: 'var(--font-brandon-grotesque)',
		fontWeight: 400,
		lineHeight: '1.2',
		wordWrap: 'break-word',
		textTransform: 'uppercase',
		// paddingBottom: remCalc(40),
		[theme.breakpoints.down('md')]: {
			// paddingBottom: remCalc(20),
			fontSize: remCalc(23),
			letterSpacing: '0.5px',
		}
	},
	'.crowdRiffGallery__hashtag': {
		color: getColor('ivory', 700),
		fontSize: remCalc(61),
		fontFamily: 'var(--font-brandon-grotesque)',
		fontWeight: 400,
		lineHeight: '1.1',
		letterSpacing: '0.5px',
		wordWrap: 'break-word',
		textTransform: 'uppercase',
		paddingBottom: remCalc(25),
		[theme.breakpoints.down('md')]: {
			fontSize: remCalc(32),
		}
	}
};

const styles = {};

export { styles };
export default styles;